import React from "react";
import AudioContent from "./components/AudioContent/AudioContent";
import { IAdminFireBase } from "@/store/models/admin.models";
import { withAdmin } from "@/services/withAdmin";
import styles from "../ContentPage/VideoPage.module.scss";
import Layout from "@/components/Layout/Layout";

const MusicPageCmp: React.FC<{ admin: IAdminFireBase }> = ({ admin }) => {
  return (
    <Layout admin={admin}>
      <div className={styles.blocks}>
        <AudioContent />
      </div>
    </Layout>
  );
};

export const MusicPage = withAdmin(MusicPageCmp);
MusicPageCmp.displayName = "MusicPageCmp";

